module.exports = __webpack_public_path__ + "img/FATdrop.ab974ef8.svg";